export default __webpack_public_path__ + "static/media/MAC.90fe7c31.svg";